import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import Alert from 'react-s-alert';
import { ServerIp } from '../constants/env';

import { Button } from './Button';
import { ProgressBar } from './ProgressBar';

export class Upload extends Component {
  constructor(props) {
    super(props);
    this.handleDrop = this.handleDrop.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.getStatus = this.getStatus.bind(this);
    this.state = {
      file: null,
      fileName: '',
      progress: null,
      id: null,
    };
  }

  handleDrop(files) {
    const file = files[0];
    this.setState({ fileName: file.name });

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      const cutBaseString = e.target.result.split(',')[1];
      this.setState({ file: cutBaseString });
    };
  }

  async getStatus(id) {
    // const { progress } = this.state;
    const res = await fetch(`${ServerIp}/api/v1/worker_status/${id}`);
    if (res.status === 200) {
      const data = await res.json();
      if (data.status !== 'Finished' && data.percentage !== 100) {
        this.setState({progress: data.percentage || 0, id: data.id});
        setTimeout(() => this.getStatus(id), 1000);
      } else {
        this.props.handleClose();
        Alert.success('File is Uploaded!');
        this.props.fetchAll();
      }
    } else {
      Alert.error('File is required required');
    }
  }

  async handleUpload() {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');

    const res = await fetch(`${ServerIp}/api/v1/zip_upload/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token token="${token}", identifier="${user}"`,
      },
      body: JSON.stringify({ zip_upload: { encoded_zip_file: this.state.file } }),
    });

    if (res.status === 200) {
      const data = await res.json();

      if (data.status !== 'Finished') {
        await this.setState({progress: 0, id: data.worker_id.id});
        setTimeout(() => {
          this.getStatus(data.worker_id.id);
        }, 2000);
      }
    } else {
      Alert.error('File is required required');
    }
  }

  render() {
    const { fileName, progress } = this.state;

    return (
      <div style={{padding: '20px'}}>
        <Dropzone
          onDrop={this.handleDrop}
          style={{
            maxWidth: '900px',
            width: '100%',
            margin: '20px auto',
            border: '2px dashed #ccc',
            padding: '80px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {fileName === '' ?
            <span>
              Drop some files here, or click to select files to upload only one file
            </span> :
            <span>
              {fileName}
            </span>
          }
        </Dropzone>
        <hr />
        <h5>
          {progress === 0 ? 'Working...' : ''}
        </h5>
        {progress !== null && <ProgressBar progress={progress} />}
        <br/>
        <hr />
        <Button
          block
          onClick={this.handleUpload}
        >
          UPLOAD
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Upload.js